import React, {useEffect, useState} from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableRow,
} from "../ui/table";
import {useNavigate} from "react-router";
import {apiRequestWithAuth} from "../../utils/api";
import {useSearchParams} from "react-router-dom";
import {EditIcon} from "../../icons";

interface Post {
    id: number;
    orderNo: number;
    title: string;
    slug: string;
    shortDescription: string;
    categoryId: string;
    category: {
        id: string;
        title: string;
    },
    files: [
        {
            metaKey: string;
            publicPath: string;
        }
    ],
    createTime: string;
    status: string;
    statusText: string;
}

type listProps = {
    type: string | number; // hoặc cụ thể hơn: type: '1' | '2' | '3';
    router: string | number;
};

export default function ListComponent({ type, router }: listProps) {

    const [searchParams, setSearchParams] = useSearchParams();
    const [pageId, setPage] = useState(() => {
        return parseInt(searchParams.get('page') || '1', 10);
    });
    const [hasResult, setHasResult] = useState(true);

    const [posts, setPosts] = useState<Post[]>([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchPosts();
    }, [pageId]);

    const handlePageChange = (newPage: React.SetStateAction<number>) => {
        setPage(newPage);
        setSearchParams({ page: newPage.toString() });
    };

    const fetchPosts = async () => {
        try {
            const response = await apiRequestWithAuth("/posts?type="+type+"&page="+pageId, "GET", {});
            if (response.messageCode === 200) {
                setPosts(response.result);
                if (response.result.length === 20) {
                    setHasResult(true);
                } else {
                    setHasResult(false);
                }
            } else {
                setPosts([]);
                setHasResult(false);
            }
            setLoading(false);
        } catch (err) {
            console.error("Error fetching post:", err);
        }
    };

    const addPost = () => {
        navigate("/create-"+router);
    };

    if (loading) return <p>Loading courses...</p>;

    return (
        <>
            <button
                className="mb-4 bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-lg shadow-md transition duration-300"
                onClick={addPost}
            >
                + Add Post
            </button>

            <div
                className="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-white/[0.05] dark:bg-white/[0.03]">
                <div className="max-w-full overflow-x-auto">
                    <div className="min-w-[1102px]">
                        <Table>
                            {/* Table Header */}
                            <TableHeader className="border-b border-gray-100 dark:border-white/[0.05]">
                                <TableRow>
                                    <TableCell
                                        isHeader
                                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400 text-nowrap"
                                    >
                                        ID
                                    </TableCell>
                                    <TableCell
                                        isHeader
                                        className="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400 text-nowrap"
                                    >
                                        STT
                                    </TableCell>
                                    <TableCell
                                        isHeader
                                        className="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400 text-nowrap"
                                    >
                                        Hình ảnh
                                    </TableCell>
                                    <TableCell
                                        isHeader
                                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400 text-nowrap"
                                    >
                                        Tên
                                    </TableCell>
                                    <TableCell
                                        isHeader
                                        className="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400 text-nowrap"
                                    >
                                        Danh mục
                                    </TableCell>
                                    <TableCell
                                        isHeader
                                        className="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400 text-nowrap"
                                    >
                                        Trạng thái
                                    </TableCell>
                                    <TableCell
                                        isHeader
                                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400 text-nowrap"
                                    >
                                        Ngày tạo
                                    </TableCell>
                                    <TableCell
                                        isHeader

                                        className="px-5 py-3 font-medium text-gray-500 text-end text-theme-xs dark:text-gray-400 text-nowrap">
                                        Hành động
                                    </TableCell>
                                </TableRow>
                            </TableHeader>


                            {/* Table Body */}
                            <TableBody className="divide-y divide-gray-100 dark:divide-white/[0.05]">
                                {posts.map((post) => (
                                    <TableRow key={post.id}>
                                        <TableCell
                                            className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                            {post.id}
                                        </TableCell>
                                        <TableCell
                                            className="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400">
                                            {post.orderNo}
                                        </TableCell>
                                        <TableCell
                                            className="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400">
                                            <img className="mx-auto" style={{maxWidth: '120px', maxHeight: '90px'}}
                                                 src={post.files[0]?.publicPath} alt=""/>
                                        </TableCell>
                                        <TableCell className="px-5 py-4 sm:px-6 text-start">
                                            <div className="flex items-center gap-3">
                                                <div>
                                                  <span
                                                      className="block font-medium text-gray-800 text-theme-sm dark:text-white/90">
                                                    {post.title}
                                                  </span>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell
                                            className="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400">
                                            {post?.category?.title || 'Chưa có danh mục'}
                                        </TableCell>
                                        <TableCell
                                            className="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400">
                                            <span
                                                className={`inline-flex items-center px-2.5 py-0.5 justify-center gap-1 rounded-full font-medium text-theme-xs
                                                ${post.statusText == 'Active' ? 'bg-success-50 text-success-600 dark:bg-success-500/15 dark:text-success-500' : 'bg-error-50 text-error-600 dark:bg-error-500/15 dark:text-error-500'}`}>
                                              {post.statusText}
                                            </span>
                                        </TableCell>
                                        <TableCell
                                            className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                                            {post.createTime}
                                        </TableCell>
                                        <TableCell className="px-4 py-3 text-end">
                                            <button onClick={() => navigate(`/${router}/${post.id}/update`)}
                                                    className="text-sm px-1.5 py-1.5 rounded-md bg-indigo-100 text-indigo-600 hover:bg-indigo-200 transition">
                                                <EditIcon />
                                            </button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <div className="p-4 border-t border-gray-100 dark:border-gray-800 sm:p-6">
                            <div className="space-y-6">
                                <div className="flex items-center justify-between gap-8 sm:justify-between">
                                    <button
                                        disabled={pageId === 1}
                                        onClick={() => handlePageChange(pageId - 1)}
                                        className="flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200 sm:px-3.5 sm:py-2.5"
                                    >
                                        <svg className="fill-current" width="20" height="20" viewBox="0 0 20 20"
                                             fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M2.58203 9.99868C2.58174 10.1909 2.6549 10.3833 2.80152 10.53L7.79818 15.5301C8.09097 15.8231 8.56584 15.8233 8.85883 15.5305C9.15183 15.2377 9.152 14.7629 8.85921 14.4699L5.13911 10.7472L16.6665 10.7472C17.0807 10.7472 17.4165 10.4114 17.4165 9.99715C17.4165 9.58294 17.0807 9.24715 16.6665 9.24715L5.14456 9.24715L8.85919 5.53016C9.15199 5.23717 9.15184 4.7623 8.85885 4.4695C8.56587 4.1767 8.09099 4.17685 7.79819 4.46984L2.84069 9.43049C2.68224 9.568 2.58203 9.77087 2.58203 9.99715C2.58203 9.99766 2.58203 9.99817 2.58203 9.99868Z"
                                                  fill=""></path>
                                        </svg>
                                        <span className="hidden sm:inline"> Previous </span>
                                    </button>
                                    <button
                                        disabled={!hasResult}
                                        onClick={() => handlePageChange(pageId + 1)}
                                        className="flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200 sm:px-3.5 sm:py-2.5">
                                        <span className="hidden sm:inline"> Next </span>
                                        <svg className="fill-current" width="20" height="20" viewBox="0 0 20 20"
                                             fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M17.4165 9.9986C17.4168 10.1909 17.3437 10.3832 17.197 10.53L12.2004 15.5301C11.9076 15.8231 11.4327 15.8233 11.1397 15.5305C10.8467 15.2377 10.8465 14.7629 11.1393 14.4699L14.8594 10.7472L3.33203 10.7472C2.91782 10.7472 2.58203 10.4114 2.58203 9.99715C2.58203 9.58294 2.91782 9.24715 3.33203 9.24715L14.854 9.24715L11.1393 5.53016C10.8465 5.23717 10.8467 4.7623 11.1397 4.4695C11.4327 4.1767 11.9075 4.17685 12.2003 4.46984L17.1578 9.43049C17.3163 9.568 17.4165 9.77087 17.4165 9.99715C17.4165 9.99763 17.4165 9.99812 17.4165 9.9986Z"
                                                  fill=""></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}